module.exports = __webpack_public_path__ + "static/media/Bayu.515cdb32.jpg";